import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react';
import { Delete16Regular } from '@fluentui/react-icons';
import './CSS/CustomEdge.css';
/**
 * Edge personnalisé avec bouton de suppression (X)
 * Affiche un bouton noir au survol pour supprimer la liaison
 */
const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  label,
  data,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  /**
   * Suppression de l'edge
   */
  const onEdgeDelete = (evt) => {
    evt.stopPropagation();
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };
  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          className="custom-edge-label-wrapper"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          {/* Label de l'edge */}
          {label && <div className="custom-edge-label">{label}</div>}
          {/* Bouton de suppression (icône corbeille mauve) */}
          <button
            className="custom-edge-delete-btn"
            onClick={onEdgeDelete}
            title="Supprimer la liaison"
          >
            <Delete16Regular />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
export default CustomEdge;
